import { Button, Dropdown } from 'antd';
import React from 'react';
import { Icon } from '@common/components';

export const TabularExportButton = ({
  children,
  loading,
  onExport,
  placement,
}: {
  children: string;
  loading: boolean;
  onExport: (format: 'csv' | 'tsv' | 'xlsx') => void;
  placement?: 'bottomLeft' | 'topRight';
}) => {
  const menuItems = [
    {
      key: 'csv',
      label: (
        <a onClick={() => onExport('csv')}>Comma-separated Values (.csv)</a>
      ),
    },
    {
      key: 'xlsx',
      label: <a onClick={() => onExport('xlsx')}>Microsoft Excel (.xlsx)</a>,
    },
    {
      key: 'tsv',
      label: <a onClick={() => onExport('tsv')}>Tab-separated Values (.tsv)</a>,
    },
  ];

  return (
    <Dropdown
      className="tabular-export-dropdown"
      menu={{ items: menuItems }}
      placement={placement}
      trigger={['click']}
      getPopupContainer={(trigger) => trigger.parentNode as HTMLElement}
    >
      <Button loading={loading}>
        <Icon icon="fileExport" kind="light" size="md" />
        <span style={{ margin: '0 8px' }}>{children}</span>
        <Icon icon="chevronDown" kind="light" />
      </Button>
    </Dropdown>
  );
};
